<template>
    <CRow alignVertical="center">
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    <h5>
                        {{ $t("Fields mapping") }}
                    </h5>
                </CCardHeader>
                <CCardBody>
                    <CCTable
                        :items="tables.mappingFields.items"
                        :fields="tables.mappingFields.fields"
                        :resizable="false"
                    >
                        <template #no-items-view>
                            <div class="block-no-items section">
                                <h2 class="section__title text-no-items">
                                    {{ $t("Add the fields to mapping") }}
                                </h2>
                                <CButton
                                    color="success"
                                    class="button m-2 shadow"
                                    @click="addItemToTable('mappingFields')"
                                >
                                    <span class="button__icon">
                                        <CIcon
                                            :content="$options.icons.cilPlus"
                                        />
                                    </span>
                                    <span class="button__text">
                                        {{ $t("Add field") }}
                                    </span>
                                </CButton>
                            </div>
                        </template>
                        <template #under-table>
                            <CButton
                                color="success"
                                class="button m-2 shadow"
                                @click="addItemToTable('mappingFields')"
                                v-if="tables.mappingFields.items.length > 0"
                            >
                                <span class="button__icon">
                                    <CIcon :content="$options.icons.cilPlus" />
                                </span>
                                <span class="button__text">
                                    {{ $t("Add field") }}
                                </span>
                            </CButton>
                        </template>
                        <template #key="{ index }">
                            <SelectFields
                                :value.sync="
                                    tables.mappingFields.items[index].key
                                "
                                :placeholder="$t('Select a field')"
                                :invalidFeedback="$t('Field is requiered')"
                                size="sm"
                                class="mb-0"
                                optionsValue="code"
                                optionsLabel="name"
                                :typeSelect="'SearchSelect'"
                                :advanceMode="true"
                                uses="DELIVERY"
                            />
                        </template>
                        <template #name="{ index }">
                            <CInput
                                :value.sync="
                                    tables.mappingFields.items[index].name
                                "
                                :placeholder="$t('enter_the_value')"
                                :invalidFeedback="$t('value_is_required')"
                                class="mb-0"
                                size="sm"
                            />
                        </template>
                        <template #options="{ index }">
                            <div class="table-options">
                                <CButton
                                    color="danger"
                                    variant="outline"
                                    square
                                    size="sm"
                                    @click="
                                        deleteItemToTable(
                                            'mappingFields',
                                            index
                                        )
                                    "
                                >
                                    <CIcon :content="$options.icons.cilTrash" />
                                </CButton>
                            </div>
                        </template>
                    </CCTable>
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    <h5>
                        {{ $t("Fixed fields") }}
                    </h5>
                </CCardHeader>
                <CCardBody>
                    <p class="mb-0">
                        {{
                            $t(
                                "You can create fixed fields for your integration"
                            )
                        }}.
                    </p>
                    <CCTable
                        :items.sync="tables.fixedFields.items"
                        :fields="tables.fixedFields.fields"
                        :resizable="false"
                    >
                        <template #name="{ index }">
                            <CInput
                                :value.sync="
                                    tables.fixedFields.items[index].name
                                "
                                :placeholder="$t('enter_the_value')"
                                :invalidFeedback="$t('value_is_required')"
                                class="mb-0"
                                size="sm"
                            />
                        </template>
                        <template #value="{ index }">
                            <CInput
                                :value.sync="
                                    tables.fixedFields.items[index].value
                                "
                                :placeholder="$t('enter_the_value')"
                                :invalidFeedback="$t('value_is_required')"
                                class="mb-0"
                                size="sm"
                            />
                        </template>
                        <template #options="{ index }">
                            <div class="table-options">
                                <CButton
                                    color="danger"
                                    variant="outline"
                                    square
                                    size="sm"
                                    @click="
                                        deleteItemToTable('fixedFields', index)
                                    "
                                >
                                    <CIcon
                                        class="icon"
                                        :content="$options.icons.cilTrash"
                                    />
                                </CButton>
                            </div>
                        </template>
                        <template #no-items-view>
                            <div class="block-no-items section">
                                <h2 class="section__title text-no-items">
                                    {{ $t("add_fixed_field") }}
                                </h2>
                                <ButtonAdd
                                    @click="addItemToTable('fixedFields')"
                                    v-if="tables.fixedFields.items.length == 0"
                                />
                            </div>
                        </template>
                        <template #under-table>
                            <ButtonAdd
                                @click="addItemToTable('fixedFields')"
                                v-if="tables.fixedFields.items.length > 0"
                            />
                        </template>
                    </CCTable>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import TableFixedFields from "~/components/TableFixedFields.vue";
import CCTable from "~/components/CCTable";
import ButtonAdd from "~/components/ButtonAdd";
import SelectAsync from "£lement/SelectAsync";
import SelectTags from "£lement/SelectTags";

import tableMixin from "~/mixins/table.js";
import baseMixin from "~/mixins/base.js";

import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import SelectFields from "£lement/SelectFields";

export default {
    name: "CCMethodApiDownloadConfiguration",
    mixins: [baseMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    consts: {},
    options: {},
    components: {
        TableFixedFields,
        CCTable,
        SelectAsync,
        ButtonAdd,
        SelectTags,
        SelectFields,
    },
    data() {
        return {
            tables: {
                fixedFields: {
                    fields: [
                        {
                            key: "name",
                            label: "Field name",
                        },
                        {
                            key: "value",
                            label: "Field value",
                        },
                        {
                            key: "options",
                            label: "options",
                        },
                    ],
                    items: [],
                },
                mappingFields: {
                    fields: [
                        {
                            key: "key",
                            label: "Key",
                        },
                        {
                            key: "name",
                            label: "Name",
                        },
                        {
                            key: "mappingValues",
                            label: "Mapping Values",
                            _defaultValue: [],
                            _active: false,
                            active: false,
                        },
                        {
                            key: "options",
                            label: "Options",
                        },
                    ],
                    items: [],
                },
            },
        };
    },
    props: {
        value: {
            required: true,
        },
    },
    watch: {
        value(newValue) {
            if (newValue) {
                this.tables.fixedFields.items = newValue.fixedFields;
                this.tables.mappingFields.items = newValue.mappingFields;
            }
        },
        "tables.fixedFields.items": {
            handler(newValue) {
                const updateValue = {
                    ...this.value,
                    fixedFields: newValue,
                };
                this.$emit("update:value", updateValue);
                this.$emit("change", updateValue);
            },
            deep: true,
        },
        "tables.mappingFields.items": {
            handler(newValue) {
                const updateValue = {
                    ...this.value,
                    mappingFields: newValue,
                };
                this.$emit("update:value", updateValue);
                this.$emit("change", updateValue);
            },
            deep: true,
        },
    },
    methods: {},
    async mounted() {
        if (this.value) {
            this.tables.fixedFields.items = this.value.fixedFields;
            this.tables.mappingFields.items = this.value.mappingFields;
        }
    },
};
</script>

<style>
.range__not_defined {
    accent-color: gray;
}
</style>
